const ITEMS = [
  "GRAND WEDDING MANDAP",
  "MAJESTIC RECEPTION HALL",
  "ROYAL FLORAL DECOR",
  "BANQUET SUPREMACY",
  "OPENING SHORTLY",
  "NOW ENQUIRING",
];

export const Marquee = () => {
  const Row = ({ hidden = false }) => (
    <div aria-hidden={hidden} className="flex items-center shrink-0">
      {ITEMS.map((item, i) => (
        <span key={i} className="flex items-center shrink-0">
          <span
            className={`px-8 whitespace-nowrap ${
              i % 2 === 0
                ? "font-display text-sm sm:text-base tracking-[0.3em] text-[#F3E5AB]/85"
                : "font-serif-lux italic text-xl sm:text-2xl text-[#D4AF37]"
            }`}
          >
            {item}
          </span>
          <span className="text-[#D4AF37]/60 text-xs">✦</span>
        </span>
      ))}
    </div>
  );

  return (
    <section
      data-testid="editorial-marquee"
      className="relative border-y border-[#D4AF37]/20 bg-[#120204] py-6 overflow-hidden"
    >
      <div className="flex w-max marquee-track">
        <Row />
        <Row hidden />
      </div>
    </section>
  );
};

export default Marquee;
